import { Component, OnInit, Inject } from "@angular/core";
import { VngDialogRef, VNG_DIALOG_DATA, VngSelectOption } from "@vengreso/angular-components";
import { FormControl } from "@angular/forms";
import { cloneDeep } from "lodash";

@Component({
    selector: "app-category-dependency",
    templateUrl: "./category-dependency.component.html",
    styleUrls: ["./category-dependency.component.scss"],
    standalone: false
})
export class CategoryDependencyComponent implements OnInit {

  deleteType: FormControl;
  shortcutCategoryList = [];
  category = new FormControl();
  // R5: mat-select (no search) -> vng-select, data-driven; excludes the
  // category being deleted, same as the old `*ngIf="cat.id != data.data.id"`.
  categoryOptions: VngSelectOption[] = [];

  constructor(public dialogRef: VngDialogRef<CategoryDependencyComponent>,
              @Inject(VNG_DIALOG_DATA) public data: any) {
    this.deleteType = new FormControl("move");
    this.category = new FormControl();
  }

  ngOnInit(): void {
    this.shortcutCategoryList = cloneDeep(this.data.self.shortcutCategoryList);
    this.categoryOptions = (this.shortcutCategoryList || [])
      .filter((cat: any) => cat.id != this.data.data.id)
      .map((cat: any) => ({ value: cat.id, label: cat.name }));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSaveCLick(): void {
    this.data.data.dependency = {
      type: this.deleteType.value
    };

    if (this.deleteType.value === "move") {
      this.data.data.dependency.category_id = this.category.value;
    }

    this.data.self.delete(this.data.data);
    this.dialogRef.close();
  }
}
